<template>
  <div class="payment-offers">
    <div class="header-row">
      <button class="back-btn" @click="goBack">
        <!-- Inline svg for back arrow, or use img src if preferred -->
        <img src="@/assets/images/ArrowLeft.svg" alt="back" width="28px" height="28px"/>
      </button>
    </div>
    <div class="header-row">
        <span class="icon-container">
        <img src="@/assets/images/SealPercent.svg" alt="Offers" />
      </span>
      <h2 class="header-title">Payment offers</h2>
    </div>
    <div class="offers-list">
      <div
        v-for="offer in offers"
        :key="offer.id"
        class="offer-card"
        :style="{ borderLeftColor: offer.color }"
      >
        <div class="offer-content">
          <div class="offer-icon">
            <img :src="offer.bankIcon" alt="Bank" />
          </div>
          <div class="offer-text">
            <div class="offer-title-row">
              <img
                class="offer-title-icon"
                src="@/assets/images/SealPercent.svg"
                alt="Offer"
              />
              <div class="offer-title" v-html="offer.title"></div>
            </div>

            <div class="offer-desc">{{ offer.description }}</div>
          </div>

          <!-- <div class="offer-percentage">
            <img src="@/assets/images/SealPercent.svg" alt="Offer" />
          </div> -->
        </div>
        <div
          v-if="offer.minimum"
          class="offer-minimum"
          :style="{ marginLeft: offerTextLeftMargin + 'px' }"
        >
          {{ offer.minimum }}
        </div>
        
        <div
          v-if="offer.additional"
          class="offer-validity"
          :style="{ marginLeft: offerTextLeftMargin + 'px' }"
        >
          {{ offer.additional }}
        </div>
        <div
          v-if="offer.validity"
          class="offer-validity"
          :style="{ marginLeft: offerTextLeftMargin + 'px' }"
        >
          {{ offer.validity }}
        </div>
        <div
          v-if="offer.note"
          class="offer-validity"
          :style="{ marginLeft: offerTextLeftMargin + 'px' }"
        >
          {{ offer.note }}
        </div>
        <div
          v-if="offer.merchants"
          class="offer-validity"
          :style="{ marginLeft: offerTextLeftMargin + 'px' }"
        >
        <br>
          {{ offer.merchants }}
        </div>
        <div class="offer-additional"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
const offers = ref([])
// This value should match the left offset for .offer-text in flex row (icon width + icon right margin)
const offerTextLeftMargin = 71 // 47px icon width + 16px margin

onMounted(() => {
  offers.value = 
  [
    // {
    //   id: 4,
    //   bankIcon: require('@/assets/images/banks/Rebrand/Name=Sampath.svg'),
    //   color: '#F47920',
    //   title: 'Get 10% OFF – Save up to Rs. 800',
    //   description: 'With Sampath Bank cards only.',
    //   additional: 'Date : 10th - 12th April 2026',
    //   note: '',
    //   validity: 'Validity : One-time use only',
    //   merchants: '',
    // },
    // {
    //   id: 4,
    //   bankIcon:'https://koko-merchant.oss-ap-southeast-1.aliyuncs.com/bank-logos/Name%3DSeylan.svg',
    //   color: '#F05C26',
    //   title: 'Save up to Rs.1,000.00',
    //   description: 'With Seylan Bank debit cards only',
    //   additional: 'Date : 4th - 14th April 2026',
    //   note: 'Available only at selected stores.',
    //   validity: 'Validity : One-time use only',
    //   merchants: '',
    // },
    // {
    //   id: 2,
    //   bankIcon:require('@/assets/images/banks/ntb.svg'),
    //   color: '#016ECE',
    //   title: 'Save up to Rs.1,000.00',
    //   description: 'With NTB Amex and Mastercards Only.',
    //   minimum: '',
    //   validity: 'Validity : One-time use only',
    //   additional: 'Date : 1st - 5th July 2026',
    //   note: '',
    //   merchants: 'Amante,Samanmal Textiles,Mimosa & The Vanta Studios,Hameedia,Signature,Hameedia Sports,Zigzag,Chenara Dodge,Cool Planet,Fashion Bug,Thilakawardhana Textiles,Deedat,Dilly and Carlo,Richlook Fashion,Rich Look International,Naviforce LK,Spring and Summer,Street82,Street82 - Wellawatte,Jazzy Shoes,The Patchee Lanka,Wickramachchi Optician & Hearing Care,Midnightdivas,District 25,ODEL,Softlogic Brands,Arctic Hunter,supplementfactory.lk,scentminis.lk,budgethut.lk,oordinary.lk,realcosmetics.lk,shopxonline.lk,essentials.lk,britishcosmetics.com,https://libertystore.lk/,https://ceylonscience.lk/,https://scentson.lk/,DBI Ceylon,Aitken Spence Hotel Managements,Heritance Hotels,Marine Spice,Dinemore Go,Barista,Burger King,Popeyes,Baskin Robins,Delifrance,Crystal Jade,Fits Air,Mr Burger,Hotel Maradha,Acropol,The Blue Water Hotel & Spa,Glenross Living,Water Garden Sigiriya,Life Mobile Lanka,Big Deals Lanka,Abans Elite,BuyAbans.com,Abans Retail,Present solution,Nanotek Computers,Genius Mobile,X-Mobile,Baloon.lk,Dinapala Group,Baseus Colombo,The Infinity Store,iPhone Paradise,OTC,Muvestore.lk,Ugreen,Xclusive Accessories,Simplytek,TECROOT,Browns Deals,Gearz,Quantum Fitness,Supiridealz.lk,ZRI Adventures,VEERA Concepts,Smart Mobile Zone,Ewis,Laveena,Vogue Flats,StopNShop,East Star Handlooms,HadunVillas,Splash Shoes,Mobil,Chamara Hardware & Tools Store,SaveMart,Bagzone,Ves Clothing,Resemblite,Rebel Rabbit,Kito Tattoos & Tattoo supply,Tendria Clothing,Al Abayet,Galleria Milano,Rasa Padhama,Jay Leather,Suwadai.lk,Le Gift Boutique,Maxiclean,HuMed,Salon Style Station,Brands Global,ZED Apparel,Mega Deals.lk,Glamon,Chocolate House,Bestmo Mart,Creative Information Technologies,KiKi Squad,Spiritual Guru,Scentiment.lk,Le Grand Clothing,Zaccai,D M Fashion & Tech,KELY,Babyboocare,DARK DEVOS,FotoArt.lk,Warnasuiya Trade Center,Master Mobile,Coffee Chapters,Calista Clothing,Modella,Fit Fam,Adonis & Venus,SRI LANKA,Royal Leather Crafts,Inkwave,Glowhub Ceylon,FOOTSTEPS,Teqware Lanka,Chocco,Best offers,HandyBuy.lk,The care AK,Tech Wizard,Sihina Holdings,Aura Era Clothing,Trendzii,DripStop,Perfume mansion,Friends photography,Cozy Pieces,BELLI BLISS,Gadjet Zone,Lillyum Fragrance,Spotlight Infinity Studios (Pvt)Ltd,Ayka.lk,Hotel Kingland,Silver Boutique,Anytronics,Mishemo,Manasavi Counselling Center,Miracles salon and academy,Trendy Collections,Astroid Apparels,Franco Sri Lanka,BEETLE96,Mobile Marvelz,Aradya Lanka,eshop,Dias Motors Spares and Lubricants',
    // },
    //  {
    //   id: 1,
    //   bankIcon:'http://koko-merchant.oss-ap-southeast-1.aliyuncs.com/bnpl-site-cms-dev/bank-images/com_bank.svg',
    //   color: '#016ECE',
    //   title: 'Get 5% OFF',
    //   description: 'With Commercial Bank credit cards only.',
    //   minimum: '',
    //   validity: '',
    //   additional: 'Date : 1st - 5th July 2026',
    //   note: 'Available only at selected stores.',
    //   merchants: 'Amante,Samanmal Textiles,Mimosa & The Vanta Studios,Hameedia,Signature,Hameedia Sports,Zigzag,Chenara Dodge,Cool Planet,Fashion Bug,Thilakawardhana Textiles,Deedat,Dilly and Carlo,Rich Look International,Spring and Summer,Midnightdivas,Wishque',
    // },
    //  {
    //   id: 3,
    //   bankIcon: require('@/assets/images/banks/Rebrand/Name=Pan Asia.svg'),
    //   color: '#E11D25',
    //   title: 'Save 10% with Credit Cards',
    //   description: 'With Pan Asia Bank credit cards only.',
    //   minimum: '',
    //   validity: 'Validity : One-time use only',
    //   additional: 'Date : 4th - 14th April 2026',
    //   note: '',
    //   merchants: '',
    // },
    //  {
    //   id: 5,
    //    bankIcon: require('@/assets/images/banks/Peoples.svg'),
    //   color: '#FDB913',
    //   title: 'Save 5% with Credit Cards | 2.5% with Debit Cards up to Rs. 50,000.00',
    //   description: 'With Peoples Bank credit and debit cards only.',
    //   minimum: '',
    //   validity: '',
    //   additional: 'Date : 20th - 27th June 2026',
    //   note: '',
    //   merchants: '',
    // }
    // {
    //   id: 1,
    //   bankIcon: require('@/assets/images/banks/Rebrand/Name=Cargills.svg'),
    //   color: '#F05C26',
    //   title: 'Save 10% on total order',
    //   description: 'With Cargills Bank credit and debit cards only.',
    //   minimum: '',
    //   validity: ' Validity : One-time use only',
    //   additional: 'Date : 7th - 15th February 2026',
    //   note: 'Available only at selected stores below.',
    //   merchants: 'Spa Ceylon, Janet.lk, Revlon.lk, decant.lk,Delifrance, Crystal Jade, laperfumerie.lk,Amagi Aria Hotel, Amagi Beach Hotel'
    // },
    // {
    //   id: 2,
    //   bankIcon: require('@/assets/images/banks/Rebrand/Name=Seylan.svg'),
    //   color: '#F05C26',
    //   title: 'Save up to Rs.3,000.00',
    //   description: 'With Seylan Bank credit cards only.',
    //   minimum: '',
    //   validity: 'Validity : One-time use only',
    //   additional: 'Date : 14th - 15th February 2026',
    //   note: 'Available only at selected stores below.',
    //   merchants: 'Burger king, Crystal Jade, Deli france',
    // },
    // {
    //   id: 3,
    //   bankIcon: require('@/assets/images/banks/Rebrand/Name=NDB.svg'),
    //   color: '#D72427',
    //   title: 'Save up to Rs. 2,000.00',
    //   description: 'With NDB Bank credit cards only.',
    //   minimum: '',
    //   validity: '',
    //   additional: 'Date : 12th - 14th February 2026',
    //   note: 'Available only at selected stores below.',
    //   merchants: 'Stripes & Checks, The chocolate house',
    // },
    // {
    //   id: 4,
    //   bankIcon: require('@/assets/images/banks/Rebrand/Name=AMEX.svg'),
    //   color: '#016ECE',
    //   title: 'Save up to Rs.1,000.00',
    //   description: 'With NTB American Express credit and debit cards only.',
    //   additional: 'Date : 7th - 15th February 2026',
    //   note: '',
    //   validity: 'Validity : One-time use only',
    //   merchants: '',
    // },
    // {
    //   id: 5,
    //   bankIcon: require('@/assets/images/banks/Rebrand/Name=Pan Asia.svg'),
    //   color: '#ED1B25',
    //   title: 'Save up to Rs. 1,000,00',
    //   description: 'With Pan Asia Bank credit cards only.',
    //   additional: 'Date : 10th - 14th February 2026',
    //   note: '',
    //   validity: '',
    //   merchants: '',
    // },
    // {
    //   id: 6,
    //   bankIcon: require('@/assets/images/banks/Rebrand/Name=Sampath.svg'),
    //   color: '#F47821',
    //   title: 'Save up to Rs. 800.00',
    //   description: 'With Sampath Bank credit and debit cards only.',
    //   additional: 'Date : 7th - 10th February 2026',
    //   note: '',
    //   minimum: 'Minimum purchase value : Rs.5,000.00',
    //   validity: '',
    //   merchants: '',
    // }
  ]
})

function goBack() {
  window.history.back()
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500&display=swap");
.header-title {
font-size: 20px;
font-weight: 700;
line-height: 14.45px;
font-family: Inter;
color: #000;
}
.payment-offers {
  background: #fff;
  min-height: 100vh;
  padding-left: 15px;
  padding-right: 20px;
  font-family: Inter, Arial, sans-serif;
}
.header-row {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding-top: 24px;
}
.back-btn {
  background: none;
  border: none;
  padding-left: 10px;
  margin-right: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.icon-container {
  
  padding: 8px;
  margin: 0 12px 0 6px;
}
.offers-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.offer-card {
  background: #fff;
  border-radius: 20px;
  border-left: 7px solid #eee;
  box-shadow: 0 1px 4px rgba(60, 60, 60, 1.09);

}
.offer-content {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 17px 0 21.68px;
}
.offer-icon img {
  width: 47px;
  height: 47px;
  border-radius: 6px;
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.25);
}
.offer-icon {
  margin-right: 8px;
}
.offer-text {
  flex: 1 1 auto;
}
.offer-title {
font-size: 13px;
line-height: 19.27px;
font-family: Inter;
color: #49840c;
text-align: left;
font-weight: 700;
  text-align: left;
}
.offer-title .highlight {
  font-weight: 700;
  color: #3a9024;
}
.offer-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.offer-title-icon {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}
.offer-desc {
  font-weight: 400;
  font-size: 10px;
color: #000;
font-family: Poppins;
  margin-bottom: 4px;
  text-align: left;
}
.offer-percentage img {
  width: 100%;
  height: 27px;
}
/* Place additional info below and align with offer-text column */
.offer-additional {
  font-size: 9px;
font-family: Inter;
color: #6e6e6e;
      margin-top: 4px;
  margin-bottom: 15px;
  white-space: pre-line;
  text-align: left;
}
.offer-validity {
    font-size: 9px;
font-family: Inter;
color: #6e6e6e;
  white-space: pre-line;
  text-align: left;
  }

.offer-minimum {
   font-size: 9px;
font-family: Inter;
color: #6e6e6e;
      margin-top: 6px;
  white-space: pre-line;
  text-align: left;
  }

@media (max-width: 600px) {
  .payment-offers {
    padding-left: 15px;
    padding-right: 20px;
  }
  .header-row {
    margin-bottom: 22px;
    padding-top: 15px;
  }
  .offers-list {
    gap: 28px;
  }
  .offer-content {
    flex-direction: row;
    
  }
  .offer-icon img {
    width: 42px;
    height: 42px;
  }
  .offer-percentage img {
    width: 28px;
    height: 28px;
  }
  .offer-additional {
    margin-bottom: 15px;
  }
}
@media (max-width: 500px) {
    .offer-icon img {
    width: 40px;
    height: 40px;
  }
  .offers-list {
        gap: 26px;
    }
}
@media (max-width: 400px) {
    .offer-icon img {
    width: 38px;
    height: 38px;
  }
  .offers-list {
        gap: 24px;
    }
}
</style>
